import { useApi } from '@/api'

export const useCopyResource = () => {
  const api = useApi()
  const copyOf = (organizationId: string, deliverableId: string) =>
    api.api.v1.organizations({ organizationId }).deliverables({ deliverableId }).copy

  return {
    getCopy: (organizationId: string, deliverableId: string) => copyOf(organizationId, deliverableId).get(),
    updateSection: (organizationId: string, deliverableId: string, sectionId: string, body: { text?: string; name?: string }) =>
      copyOf(organizationId, deliverableId).sections({ sectionId }).patch(body),
    addSection: (organizationId: string, deliverableId: string, body: { name: string; slide?: number }) =>
      copyOf(organizationId, deliverableId).sections.post(body),
    removeSection: (organizationId: string, deliverableId: string, sectionId: string) =>
      copyOf(organizationId, deliverableId).sections({ sectionId }).delete()
  }
}
